import { Component, OnInit } from '@angular/core';
import {WaitingService} from './waiting.service';

@Component({
	selector: 'wnvw-waiting',
	templateUrl: './waiting.component.html',
	styleUrls: ['./waiting.component.scss']
})
export class WaitingComponent implements OnInit {
	waiting: boolean;

	constructor(public waiting$: WaitingService) {
		this.waiting = false;
	}

	ngOnInit(): void {
		this.waiting$.subscribe((w) => (this.waiting = w));
	}

}
